export const inviteContentTabs = {
  text: 'text',
  email: 'email'
}

export function shouldShowInviteEmailContentTab({ type, category }) {
  if (type === 'consentRequest') {
    return false
  }

  if (category?.includes('ConsentRequest')) {
    return false
  }

  return true
}
